// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"494":"d62d481287a294cb","715":"5bcf7a36ed94a036"}[chunkId] + ".js";
};